shvenergy.alertbanner = (function ($) {
	"use strict";

	function init() {

		var alertBanners = $("[data-alertbanner]");

		alertBanners.each(function () {

			var banner = $(this);
			var bannerCookieName = banner.data("alertbannercookiename");
			var bannerHasLinks = banner.find("a").length > 0;
			var bannerHasCloseButton = banner.find("[data-alertclose]").length > 0;
			var bannerDelay = banner.data("alertbanner-delay");

			if (bannerHasLinks) {

				var bannerLinks = banner.find("a");

				bannerLinks.each(function (index) {

					var currentLink = $(this);
					currentLink.on("click", function (e) {
						shvenergy.tracking.trackEvent("alertbanner", "alertbanner link clicked", this.innerText);
					});

				});

			}

			window.addEventListener("resize", () => {
				if (document.body.getAttribute("data-totop-enabled") === 'False' && window.innerWidth > 640 && window.innerWidth < 1200) {
					banner[0].style.marginTop = document.getElementsByClassName("mobile-header")[0].offsetHeight + "px";
				} else {
					banner[0].style.marginTop = "0px";
				}
			})
			if (document.body.getAttribute("data-totop-enabled") === 'False' && window.matchMedia("(min-width: 640px) and (max-width: 1199px)").matches) {
				banner[0].style.marginTop = document.getElementsByClassName("mobile-header")[0].offsetHeight + "px";
			}

			if (bannerHasCloseButton) {

				var closeButton = banner.find("[data-alertclose]");

				closeButton.on("click", function () {

					if (bannerCookieName.length > 0) {
						if (shvenergy.cookies.hasCookieCategoryConsent(bannerCookieName)) {
							shvenergy.cookies.setCookie(bannerCookieName, "true", 1);
						}
					}

					banner.remove();
				});

			}

			if (bannerDelay > 0) {
				banner.addClass('alert-banner__hidden');

				setTimeout(() => {
					banner.removeClass('alert-banner__hidden');
				}, bannerDelay * 1000);
			}
			else {
				banner.removeClass('alert-banner__hidden');
			}
		});

	}

	init();

})(jQuery);